import { render, staticRenderFns } from "./CircuitoNewversion.vue?vue&type=template&id=0eae764c"
import script from "./CircuitoNewversion.vue?vue&type=script&lang=js"
export * from "./CircuitoNewversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports